import { createSelector } from "@ngrx/store";
import { AppState } from "../reducers";

export const selectRedirect = (state: AppState) => state.routerRedirect;

export const selectRedirectUrl = createSelector(selectRedirect, (state) => state.url);

export const selectRedirectQueryParams = createSelector(
	selectRedirect,
	(state) => state.queryParams
);
